var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2034 8.92308H11.3828V36H28.6136V8.92308H27.793V6.8717C27.7922 6.11045 27.4894 5.3805 26.9509 4.84206C26.4125 4.30387 25.6825 4.00084 24.9213 4H15.0751C14.3139 4.00082 13.5839 4.30385 13.0455 4.84206C12.507 5.38052 12.2043 6.11045 12.2034 6.8717V8.92308ZM14.665 6.8717C14.665 6.64532 14.8485 6.46154 15.0751 6.46154H24.9213C25.0301 6.46154 25.1345 6.50467 25.2114 6.58159C25.2883 6.65851 25.3314 6.76291 25.3314 6.8717V8.92308H14.6652L14.665 6.8717Z",
    fill: "#EC923C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35938 31.4859C2.3602 32.6826 2.83602 33.8298 3.68192 34.676C4.52806 35.5221 5.67563 35.998 6.87201 35.9988H8.92338V8.92188H6.87201C5.67556 8.9227 4.52806 9.39852 3.68192 10.2447C2.83607 11.0908 2.36022 12.2381 2.35938 13.4348V31.4859Z",
    fill: "#EC923C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1256 8.92188H31.0742V35.9988H33.1256C34.322 35.998 35.4695 35.5222 36.3157 34.676C37.1615 33.8298 37.6374 32.6825 37.6382 31.4859V13.4351C37.6374 12.2383 37.1616 11.0911 36.3157 10.245C35.4695 9.39885 34.322 8.923 33.1256 8.92216V8.92188Z",
    fill: "#EC923C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.c2a43822.svg";
export { ForwardRef as ReactComponent };